// redux/features/inactiveUserLogsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getInactiveUserLogs } from "../../services/inactiveServices";

const initialState = {
  logs: [],
  total: 0,
  page: 1,
  status: "idle",
  error: null,
};

// GET inactive logs
export const fetchInactiveUserLogs = createAsyncThunk(
  "inactiveUserLogs/fetchInactiveUserLogs",
  async (
    { page, search, startDate, endDate, sortOrder, limit },
    { rejectWithValue }
  ) => {
    try {
      const response = await getInactiveUserLogs(
        page,
        search,
        startDate,
        endDate,
        sortOrder,
        limit // ✅ pass limit
      );
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Failed to fetch inactive user logs";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const inactiveUserLogsSlice = createSlice({
  name: "inactiveUserLogs",
  initialState,
  reducers: {
    clearInactiveUserLogsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInactiveUserLogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInactiveUserLogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.logs = action.payload.data;
        state.total = action.payload.pagination.totalUsers;
        state.page = action.payload.pagination.currentPage;
      })
      .addCase(fetchInactiveUserLogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearInactiveUserLogsError } =
  inactiveUserLogsSlice.actions;

export default inactiveUserLogsSlice.reducer;
